import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import styles from "./LosListe.module.css";

export default function List(props: {
  rowData: any[];
  tableHeaderList: { [key: string]: string };
  renderRowActions?: (row: any, rowIndex: number) => React.ReactNode;
}) {
  const { rowData, tableHeaderList, renderRowActions } = props;
  const tableHeaderLabels = Object.entries(tableHeaderList).map(
    ([key, value]) => {
      return value;
    }
  );
  const listKeys = Object.keys(tableHeaderList);
  return (
    <Box sx={{ alignSelf: "start", maxHeight: "100%", overflow: "hidden" }}>
      <Box
        sx={{
          overflowY: "auto",
          overflowX: "hidden",
          height: "100%",
          boxSizing: "content-box",
          width: "auto",
        }}
      >
        <TableContainer
          component={Paper}
          sx={{
            border: "1px solid #D0C2A8",
            borderRadius: "0px !important",
            width: "auto",
          }}
        >
          <Table
            sx={{
              minWidth: 650,
              color: "#D0C2A8",
              width: "100%",
            }}
            aria-label="simple table"
          >
            <TableHead sx={{ width: "auto" }}>
              <TableRow>
                {tableHeaderLabels.map((e, key) => (
                  <TableCell key={key} className={styles.tableHeader}>
                    <TableSortLabel hideSortIcon={true}>{e}</TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rowData.map((row: any, key: any) => (
                <TableRow key={key}>
                  {listKeys.map((key: string) =>
                    key !== "actions" ? (
                      <TableCell key={key}>{row[key]}</TableCell>
                    ) : null
                  )}
                  {renderRowActions && (
                    <TableCell>{renderRowActions(row, key)}</TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}
